import { jsx as _jsx } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import LevvyLogo from './LevvyLogo';
export default function LevvyCard() {
    const { t: texts } = useLocaleKeys('integrations.availableApps.levvy');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('levvy');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "levvy-card",
        icon: /*#__PURE__*/ _jsx(LevvyLogo, {}),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_levvy'
            },
            onClick: showCopyAPIKeyModal,
            testId: "levvy-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
